import type { SupportedLocale } from '@/app/config/app.config';

export type Direction = 'ltr' | 'rtl';

const RTL_LOCALES = new Set<SupportedLocale>(['ar']);

/**
 * Derive document direction from a locale. Unknown locales fall back to 'ltr'.
 */
export function getDirection(locale: string): Direction {
  return RTL_LOCALES.has(locale as SupportedLocale) ? 'rtl' : 'ltr';
}
